import React, { useState, useEffect } from 'react';
import './StickyLogo.css';

const StickyLogo = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Afficher le logo après avoir scrollé de 100vh (hauteur de la première page)
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      
      if (scrollPosition > windowHeight) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
        setIsMenuOpen(false); // Fermer le menu quand on retourne en haut
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <>
      <button 
        className={`menu-toggle ${isVisible ? 'visible' : ''}`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`side-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="menu-header">
          <img src="/photo/logo/MyAidgent_logo_sourire_foncer.png" alt="MyAidgent" className="menu-logo" />
          <h2 className="menu-title">MyAidgent</h2>
          <button className="menu-close" onClick={() => setIsMenuOpen(false)}>×</button>
        </div>
        
        <nav className="menu-nav">
          <button onClick={() => scrollToSection('problem')}>Problèmes</button>
          <button onClick={() => scrollToSection('solution')}>Solutions</button>
          <button onClick={() => scrollToSection('collaboration')}>Collaboration</button>
          <button onClick={() => scrollToSection('projects')}>Projets</button>
          <button onClick={() => scrollToSection('team')}>Fondateur</button>
          <button onClick={() => scrollToSection('calendar')}>Contact</button>
          <button onClick={() => scrollToSection('faq')}>FAQ</button>
        </nav>
      </div>

      {isMenuOpen && <div className="menu-overlay" onClick={() => setIsMenuOpen(false)}></div>}
    </>
  );
};

export default StickyLogo;
